import React from "react";

export const barLabelPlugin = {
  id: "barLabels",
  afterDatasetsDraw(chart) {
    const { ctx, data } = chart;
    ctx.save();
    chart.getDatasetMeta(0).data.forEach((bar, i) => {
      const val = data.datasets[0].data[i];
      ctx.fillStyle = "#fff";
      ctx.font = "bold 11px 'Segoe UI', system-ui, sans-serif";
      ctx.textAlign = "right";
      ctx.textBaseline = "middle";
      ctx.fillText(val + "%", bar.x - 6, bar.y);
    });
    ctx.restore();
  },
};

export const barLabelOutsidePlugin = {
  id: "barLabelsOutside",
  afterDatasetsDraw(chart) {
    const { ctx, data } = chart;
    ctx.save();
    chart.getDatasetMeta(0).data.forEach((bar, i) => {
      const val = data.datasets[0].data[i];
      ctx.fillStyle = "#374151";
      ctx.font = "bold 11px 'Segoe UI', system-ui, sans-serif";
      ctx.textAlign = "left";
      ctx.textBaseline = "middle";
      ctx.fillText(val + "%", bar.x + 6, bar.y);
    });
    ctx.restore();
  },
};

export const hBarOpts = (showLegend = false) => ({
  indexAxis: "y",
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: showLegend,
      position: "bottom",
      labels: { boxWidth: 14, font: { size: 11 }, color: "#475569" },
    },
    tooltip: { callbacks: { label: (ctx) => "  " + ctx.parsed.x + "%" } },
  },
  scales: {
    x: {
      min: 0,
      max: 100,
      ticks: { callback: (v) => v + "%" },
      grid: { color: "#f1f5f9" },
    },
    y: { ticks: { font: { size: 10 } } },
  },
});

export const hBarOptsNoMax = (showLegend = false) => ({
  indexAxis: "y",
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: showLegend,
      position: "top",
      labels: { font: { size: 10 }, boxWidth: 12, padding: 8 },
    },
  },
  scales: {
    x: { grid: { display: false }, ticks: { font: { size: 10 } } },
    y: { ticks: { font: { size: 10 } } },
    x1: {
      display: false, // removes the bottom axis from view entirely
    },
  },
});

export const sortBtn = (active, onClick, label) => (
  <button
    onClick={onClick}
    style={{
      background: active ? "#4f6d9a" : "#eef2f7",
      color: active ? "#fff" : "#6b7c93",
      border: "none",
      borderRadius: 4,
      padding: "2px 7px",
      fontSize: ".7rem",
      cursor: "pointer",
      fontWeight: 700,
    }}
  >
    {label}
  </button>
);
